import classNames from "classnames";
import React, { useMemo } from "react";
import { useBranding } from "src/branding/BrandingContextProvider";
import { filterAllowedStatus } from "../helpers/allowedStatus";

let statuses = [
  { label: "Submitted", key: "Submitted", id: "submitted" },
  { label: "Scheduled", key: "Scheduled", id: "scheduled" },
  { label: "En Route", key: "En Route", id: "enRoute" },
  { label: "On Hold", key: "On Hold", id: "onHold" },
  { label: "In Progress", key: "In Progress", id: "inProgress" },
  { label: "Resolved", key: "Resolved", id: "resolved" },
  { label: "Declined", key: "Declined", id: "declined" },
  { label: "Closed", key: "Closed", id: "closed" },
  { label: "Archive", key: "Archive", id: "archive" },
  { label: "Assigned", key: "Assigned", id: "assigned" },
  { label: "Under Review", key: "Under Review", id: "underReview" },
  { label: "Approved", key: "Approved", id: "approved" },
  { label: "One Year Warranty", key: "One Year Warranty", id: "oneYearWarranty" },
];

export const BulkUpdateServiceRequest = ({
  disableBulkUpdate,
  onChangeStatus,
  style,
  label="BULK STATUS UPDATE"
}) => {
  const {branding} = useBranding();
  const allowedStatuses = useMemo(() => {
    return filterAllowedStatus(statuses, branding);
  }, [statuses, branding])
  return (
    <div className="bulkUpdateServReq" style={style}>
      <select
        className={classNames("select__bulkUpdate_options", {
          "select__bulkUpdate_options--background": !disableBulkUpdate,
        })}
        disabled={disableBulkUpdate}
        onChange={(e) => onChangeStatus(e.target.value)}
        value={""}
        style={{paddingLeft: "1rem", paddingRight: "1rem", width: "100%", minWidth:'8rem'}}
      >
        <option value="">{label}</option>
        {allowedStatuses.map((stat, i) => (
          <option key={i} value={stat.label}>
            {stat.label}
          </option>
        ))}
      </select>
    </div>
  );
};
